import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Button, FieldErrorContext, ListStateContext, OverlayTriggerStateContext } from "react-aria-components";
import { XCircle as LineXCircle } from "../../icons/line.js";
import { XCircle as SolidXCircle } from "../../icons/solid.js";
import useI18n from "../internal/useI18n.js";
import * as styles from "./ClearButton.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
function useClearButtonState(hasSelection, isInvalid, isOpen) {
  const $ = _c(3);
  const [isFakeOpen, setIsFakeOpen] = React.useState(false);
  const wasOpen = React.useRef(false);
  let t0;
  let t1;
  if ($[0] !== isOpen) {
    t0 = function delayedClosing() {
      if (!isOpen && wasOpen.current) {
        wasOpen.current = false;
        setTimeout(() => {
          setIsFakeOpen(false);
        }, 200);
      } else {
        if (isOpen && !wasOpen.current) {
          wasOpen.current = true;
          requestAnimationFrame(() => {
            setIsFakeOpen(true);
          });
        }
      }
    };
    t1 = [isOpen];
    $[0] = isOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  React.useEffect(t0, t1);
  const isListBoxOpen = isOpen || isFakeOpen;
  let visible;
  if (isInvalid) {
    visible = isFakeOpen && !isListBoxOpen ? "delayed" : isListBoxOpen;
  } else {
    visible = hasSelection;
  }
  return visible;
}
export const ClearButton = t0 => {
  const $ = _c(13);
  const {
    clearButton,
    isOpen: t1,
    hasSelection: t2,
    onClear
  } = t0;
  const isOpenProp = t1 === undefined ? false : t1;
  const hasSelectionProp = t2 === undefined ? false : t2;
  const isOverlayOpen = React.useContext(OverlayTriggerStateContext)?.isOpen === true || isOpenProp;
  const i18n = useI18n();
  const listState = React.useContext(ListStateContext);
  const hasSelection = listState?.selectionManager.firstSelectedKey != null || hasSelectionProp;
  const errorState = React.useContext(FieldErrorContext);
  const isInvalid = errorState?.isInvalid === true;
  const visible = useClearButtonState(hasSelection, isInvalid, isOverlayOpen);
  if (clearButton === false) {
    return null;
  }
  let t3;
  if ($[0] !== listState || $[1] !== onClear) {
    t3 = () => {
      if (listState) {
        listState.selectionManager.setSelectedKeys(new Set());
      } else {
        onClear?.();
      }
    };
    $[0] = listState;
    $[1] = onClear;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== visible) {
    t4 = styles.clearButton({
      isVisible: visible
    });
    $[3] = visible;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== clearButton || $[6] !== i18n) {
    t5 = typeof clearButton === "string" ? clearButton : i18n.format("clearButton");
    $[5] = clearButton;
    $[6] = i18n;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = visible === false;
  let t7;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = /*#__PURE__*/_jsx(Button, {
      slot: null,
      onPress: t3,
      className: t4,
      "aria-label": t5,
      isDisabled: t6,
      children: _temp
    });
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
function _temp(t0) {
  const {
    isFocused
  } = t0;
  return isFocused ? /*#__PURE__*/_jsx(SolidXCircle, {
    className: styles.clearButtonIcon
  }) : /*#__PURE__*/_jsx(LineXCircle, {
    className: styles.clearButtonIcon
  });
}
//# sourceMappingURL=ClearButton.js.map